var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 14.6667C2.96523 14.6667 2.66675 14.3682 2.66675 14V1.99999C2.66675 1.63181 2.96523 1.33333 3.33341 1.33333H12.6667C13.0349 1.33333 13.3334 1.63181 13.3334 1.99999V3.99999H12.0001V2.66666H4.00008V13.3333H12.0001V12H13.3334V14C13.3334 14.3682 13.0349 14.6667 12.6667 14.6667H3.33341ZM12.0001 10.6667V8.66666H7.33341V7.33333H12.0001V5.33333L15.3334 7.99999L12.0001 10.6667Z",
    fill: "#AE2E24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutLine);
export default __webpack_public_path__ + "static/media/logoutLine.c0c1690a74326ed8f475782aa3f7f5f7.svg";
export { ForwardRef as ReactComponent };